import React, { useEffect, useState } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import QualityMonitoringSetups from '../features/quality-monitoring/QualityMonitoringSetups'
import QualityMonitringSetupPlants from '../features/quality-monitoring/QualityMonitoringSetupPlants'
import PageNotFound from './PageNotFound'
import Api from '../api'
import { CircularProgress } from '@mui/material'

const tabsMap = [
  { id: '1', name: 'ID' },
  { id: '2', name: 'DAH' },
  // { id: '3', name: 'composite_1h' },
]

const QMApp = props => {
  const { history, container } = props
  const [isLoading, setIsLoading] = useState(true)
  const [allSetups, setAllSetups] = useState([])
  const [mainTabValue, setMainTabValue] = useState(tabsMap[0])
  const [activeView, setActiveView] = useState('active') // active setups view by default

  const handleActiveToggle = newValue => {
    setActiveView(newValue)
  }

  const goToHomepage = () => {
    history.push('/monitoring')
  }

  useEffect(() => {
    const fetchAllSetups = async () => {
      try {
        const response = await Api.Setups.getUserSetups()

        const allUserSetups = Array.isArray(response.data.setups)
          ? response.data.setups
          : []

        setAllSetups(allUserSetups)
      } catch (error) {
        console.error('Error fetching client setups:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchAllSetups()
  }, [])

  return (
    <>
      <Switch>
        <Route exact path={`/monitoring`}>
          <Redirect to={`/monitoring/client`} />
        </Route>

        <Route
          path={`/monitoring/client`}
          exact
          render={props => (
            <QualityMonitoringSetups
              {...props}
              container={container}
              mainTabValue={mainTabValue}
              setMainTabValue={setMainTabValue}
              tabsMap={tabsMap}
              activeView={activeView}
              handleActiveToggle={handleActiveToggle}
            />
          )}
        />

        <Route
          path={`/monitoring/client/:id`}
          exact
          render={props => {
            const { id } = props.match.params

            if (isLoading) {
              return (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '80vh',
                    width: '100%',
                    overflowY: 'hidden',
                  }}
                >
                  <CircularProgress />
                </div>
              )
            }
            const validSetup = allSetups.find(el => el.name === id)
            if (!validSetup) {
              return <Redirect to="/monitoring/client" />
            }

            return (
              <QualityMonitringSetupPlants
                {...props}
                selectedSetup={validSetup}
                mainTabValue={mainTabValue}
                setMainTabValue={setMainTabValue}
                tabsMap={tabsMap}
                isActiveViewSetup={activeView}
              />
            )
          }}
        />

        <Route render={props => <PageNotFound goToHomepage={goToHomepage} />} />
      </Switch>
    </>
  )
}

export default withRouter(QMApp)
